<template>
  <DisplayFlex tag="nav" class="nav"><slot /> </DisplayFlex>
</template>
<script lang="ts" setup></script>
<style lang="scss" scoped>
.nav {
  flex-direction: column;
  justify-content: flex-start;
  gap: var(--gap_xs);
  width: 100%;
}
</style>
